<template>
    <div>
        <div v-if="dataPermission && dataPermission.includes('NSH_IAM_USERROLE_UPDATE')">
            <loading v-if="loading"></loading>
            <div class="header">
                <div class="layout-wrapper">
                    <header id="page-topbar">
                        <BaseButton variant="secondary" @click="confirmModal = true">Quay lại</BaseButton>
                    <div class="title">
                        <p>Sửa vai trò</p>
                    </div>
                        <el-button type="primary" @click="submit">Lưu thay đổi</el-button>
                    </header>
                </div>
            </div>

            <div class="boxContent boxContentExt" style="margin-top:110px">
                <div class="__card first-box">
                    <LayoutCardTitle>Vai trò nhân viên</LayoutCardTitle>
                    <el-row>
                        <el-col>
                            <span class="role-descrpition">Với mỗi chi nhánh, nhân viên chỉ có thể được gán một vai trò </span>
                        </el-col>
                    </el-row>
                    
                    <el-form label-width="160px" style="width: 100%;" :inline="true">
                        <el-row style="margin-bottom:24px">
                            <el-col :span="12">
                                <el-form-item label="Vai trò" prop="name" class="mb-0">
                                    <Select2
                                        :options="MCroles"
                                        placeholder="Chọn vai trò"
                                        v-model="selectRole"
                                        @change="checkRole($event)"/>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item prop="name" class="mb-0 locations">
                                    <Select2
                                        :options="locations"
                                        v-model="selectLocation"
                                        placeholder="Chọn chi nhánh"
                                        @change="checkLocation($event)"/>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-button v-if="!selectLocation || !selectRole" disabled style="margin-left: 16px" type="info">Gán vai trò</el-button>
                                <el-button @click="checkValidate" v-else style="margin-left: 16px" type="primary" plain>Gán vai trò</el-button>
                            </el-col>
                        </el-row>
                    </el-form>

                    <el-row class="w-100">
                        <b-table :items="employeeRoles" :fields="theadDetail">
                            <template v-if="!employeeRoles.length > 0" #table-caption>
                                <div class="text-center mt-5 mb-5 empty-return-table">
                                    <p>Chưa có vai trò nhân viên</p>
                                </div>
                            </template>
                            <template #cell(indexRole)="data">{{ data.index + 1 }}</template>
                            <template #cell(role)="data">
                            <span @click="openRoleModal(data.item.roleId)" style="cursor: pointer; color:#3E69F6">{{data.item.role}}</span>
                            </template>
                            <template #cell(remove)="data">
                            <span @click="employeeRoles.splice(data.index, 1)">
                            <img src="@/assets/images/delete-vector.png"/>
                            </span>
                            </template>
                        </b-table>
                    </el-row>
                </div>
            </div>

            <el-dialog title="Phân quyền vai trò" :visible.sync="roleModal" width="600px" :close-on-click-modal="false" append-to-body>
                <div>
                <div style="margin-bottom: 12px;word-break: break-word;" v-for="item, id in groupPermissions" :key="id">
                    <b>{{item.groupName}}: </b>{{renderPermissionsList(item)}}
                </div>
                </div>
                <template slot="footer">
                    <el-button class="esc-btn" type="text" @click="roleModal = false" style="margin-right: 20px;">Thoát</el-button>
                    <el-button
                    type="primary"
                    @click="() => $router.push(`/employee-and-role/role-edit/${this.roleId}`)"
                    >
                    Sửa phân quyền
                    </el-button>
                </template>
            </el-dialog>
            

            <el-dialog title="Hủy chỉnh sửa" :visible.sync="confirmModal" width="600px" :close-on-click-modal="false" append-to-body>
                <div class="text-center">
                    <div class="modal-img"><img src="@/assets/employee-and-role-icons/warning.png" /></div>
                    <p>Mọi chỉnh sửa của vai trò sẽ không được lưu lại. Bạn chắc chứ?</p>
                </div>
                <template slot="footer">
                    <el-button class="esc-btn" type="text" @click="confirmModal = false">Thoát</el-button>
                        <el-button
                        type="primary"
                        @click="confirmGoBack"
                        >
                            Đồng ý
                        </el-button>
                </template>
            </el-dialog>
        </div>
        <NotPermission v-else></NotPermission>
    </div>
</template>

<script>
import { RoleService } from '@/services/nextshop/role.service';
import { LocationService } from '@/services/nextshop/location.service';
import { EmployeeService } from '@/services/nextshop/employee.service';
    export default {
        data() {
            return {
                dataPermission: JSON.parse(localStorage.getItem("dataPermission")),
                inforAccount: JSON.parse(localStorage.getItem("auth.currentUser")),
                idEmployee: this.$route.params.id,
                loading: false,
                selectRole: '',
                locations: [],
                selectLocation: null,
                sel: {
                    locationId: null,
                    roleId: null
                },
                roleId: '',
                groupPermissions: [],
                roleModal: false,
                employeeRoles: [],
                MCroles: [],
                theadDetail: [
                    { key: 'indexRole', label: 'STT' },
                    { key: 'role', label: 'Vai trò' },
                    { key: 'location', label: 'Chi nhánh' },
                    { key: 'remove', label: '' }, 
                ],
                confirmModal: false,
                dataItem: {},
            }
        },

        created() {
            this.getDetailEmployeeById();
            this.getListRole();
            this.getListLocation();
        },

        methods: {
            async getDetailEmployeeById() {
                try {
                    this.loading = true
                    const dataRes = await EmployeeService.getDetailEmployee({
                        aliasUserId: this.idEmployee
                    })
                    if (dataRes.success) {
                        this.employeeRoles = dataRes.data.roles.map((e) => {
                        return {
                            role: e.roleName,
                            location: e.locationName,
                            locationId: e.locationId,
                            roleId: e.roleId
                            }
                        })
                    }
                } catch (error) {
                    console.log(error);
                } finally {
                    this.loading = false
                }
            },

            async submit() {
                this.loading = true
                let param = {
                    id: this.idEmployee,
                    roles: {
                        roles: this.employeeRoles.map((e) => {
                            return {
                                locationId: e.locationId,
                                roleId: e.roleId
                            }
                        })
                    }
                }
                try {
                    const dataRes = await EmployeeService.updateEmployeeRoles(param)
                    if (dataRes.success) {
                        this.$message({
                        dangerouslyUseHTMLString: true,
                        message: '<h5 style="color:#67c23a">Sửa vai trò thành công</h5>',
                        type: 'success'
                        })
                        this.$router.push(`/employee-and-role/employee-detail/${this.idEmployee}`)
                    }
                } catch (error) {
                    console.log(error);
                }
            },

            async openRoleModal(id) {
                this.loading = true
                this.roleId = id;
                try {
                    const params = {
                        roleId: this.roleId,
                        lang: "vn",
                    };
                    const dataRes = await RoleService.getItemRole(params);
                    if (dataRes.success) {
                        this.groupPermissions = dataRes.data.groupPermissions;
                        this.loading = false
                        this.roleModal = true
                    }
                } catch (error) {
                    console.log(error);
                }
            },

            renderPermissionsList(item) {
                let subPermissionsList = [];
                if(item.permissions && item.permissions.length > 0) {
                    for (let i of item.permissions) {
                    subPermissionsList.push(i.permissionName)
                    }
                }
                return subPermissionsList.join(', ');
            },

            async getListRole() {
                try {
                    const dataRes = await RoleService.getListRole({
                        sort: "DESC",
                        sortBy: 'createdAt',
                        limit: 100,
                        page: 1,
                        merchantId: this.inforAccount.merchantId
                    })
                    if (dataRes.data.length > 0) {
                    this.MCroles = dataRes.data.map((e) => {
                        return {
                            appId: e.appId,
                            id: e.roleId,
                            text: e.roleName
                        }
                    })
                    } else {
                    this.MCroles = [{
                        id: null,
                        text: 'Chưa có dữ liệu'
                    }]
                    }
                } catch (error) {
                    console.log(error);
                }
            },
            // lấy list location của MC
            async getListLocation() {
                try {
                    const dataRes = await LocationService.getListLocation({
                        coStatus: "ACTIVE",
                        limit: 1000,
                        page: 1,
                        status: "",
                        textSearch: null,
                        sortBy: "name",
                        sort: "ASC",
                        merchantId: this.inforAccount.merchantId
                    })
                    if (dataRes.data.length > 0) {
                    dataRes.data.map(e => this.locations.push({
                        id: e.coLocationId,
                        text: e.name
                    }))
                    if(this.locations.length == 1) {
                        this.sel.locationId = this.locations[0].id
                        this.selectLocation = this.locations[0].id
                    }
                    } else {
                    this.locations = [{
                        id: null,
                        text: 'Chưa có dữ liệu'
                    }]
                    }
                } catch (error) {
                    console.log(error);
                }
            },

            //gán chi nhánh
            checkLocation(e) {
                this.sel.locationId = e 
            },
            // gán vai trò
            checkRole(e) {
                this.sel.roleId = e
            },
            // validate của Role và Location
            checkValidate() {
                const rel = this.employeeRoles.findIndex((el) => (
                    (el.roleId == this.sel.roleId && el.locationId == this.sel.locationId) || (el.locationId == this.sel.locationId)
                ))
                if (this.selectLocation == null || this.selectRole == null) {
                    this.msgError = 'Vai trò và Chi nhánh không được để trống !'
                } else if (rel != -1) {
                    this.$message.error({
                    dangerouslyUseHTMLString: true,
                    message: '<h5 style="color:#DC2323">Gán vai trò thất bại</h5><p style="color:#23313E">Nhân viên đã được gán vai trò khác tại chi nhánh này</p>',
                    });
                    this.msgError = ''
                } else {
                    this.msgError = ''
                    this.addNewRow()
                }
                this.selectRole = null
                if(this.locations.length !== 1) {this.selectLocation = null}
            },

            addNewRow() {
                const locationTable = this.locations.find(e => e.id === this.selectLocation)
                const roleTable = this.MCroles.find(e => e.id === this.selectRole)
                this.employeeRoles.push({
                    roleId: this.selectRole,
                    locationId: this.selectLocation,
                    role: roleTable.text,
                    location: locationTable.text
                })
                this.selectRole = null
                if(this.locations.length !== 1) {this.selectLocation = null}
            },

            confirmGoBack() {
                this.$router.push(`/employee-and-role/employee-detail/${this.idEmployee}`)
            }
        }
    }
</script>

<style lang="scss" scoped>
.boxContent .__card {
  max-width: 960px;
  padding: 24px;
}
.layout-wrapper {
  position: relative;

  #page-topbar {
    display: flex;
    justify-content: space-between;
    padding: 16px 24px;

    .title{
      position: absolute;
      font-weight: 600;
      font-size: 24px;
      color: #23313e;
      cursor: pointer;
      left: 50%;
      -webkit-transform: translateX(-50%);
      transform: translateX(-50%);
      align-self: center;
      
      p {
        margin: 0;
      }
    }
    
    .content {
      margin-top: 5.5em;
      padding: 20px 16.6% 120px 16.6%;
      min-height: 80vh;
    }
  }
}
</style>

<style lang="scss">
.boxContent {
  margin: 12px 0;
}

.el-select {
    width: 100%;
}

.el-form-item {
  width: 100%;
  margin-bottom: 0;
}

.locations .el-form-item__content {
    width:100%;
}

.el-form-item__label {
  color: #9093A4;
}

.el-form-item__content {
  width: 60%;
}
.el-dialog__body {
  max-height: 300px;
  overflow: auto;
}
.day-of-birth input{
  font-size: 14px !important;
}
.role-descrpition {
    padding: 10px 16px;
    width: 440px;
    height: 42px;
    background: #FFF9EC;
    border-radius: 4px;
}
</style>>

